var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	}
};

site.responsive = {
	tables: function() {
		if (!$('body').is('.admin')) {
			$('table', 'main').wrap('<div class="table-responsive"></div>');
		}
	},

	videos: function() {
		$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function() {
			$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px">'
				+ '<div class="embed-responsive embed-responsive-16by9"></div></div>');
		});
	}
};

site.divisionPicker = {
	init: function() {
		let $divisionPicker = $('.division__picker');
		if (!$divisionPicker.length) {
			return false;
		}

		$divisionPicker.clone().appendTo('#mainmenu');
		site.maxHeight.init('.divisionPicker');
		site.toggle.init('.divisionToggle', '.divisionPicker', 'divisionPicker');

		$('.divisionPicker', '#mainmenu').attr('id', 'divisionPickerMobile');
		$('.divisionToggle', '#mainmenu').attr('aria-controls', 'divisionPickerMobile');
	}
};

site.content = {
	init: function() {
		$('.content__quote').closest('.box').addClass('box_quote');
	}
};

site.frontpage = {
	init: function() {

	}
};

$(function() {
	const $body = $('body');
	$body.removeClass('preload');
	// Responsive tables
	if (!$('body').is('.admin')) {
		$('table', '#contentContainer').each(function() {
			if (!$(this).parent().hasClass('responsiveTable')) {
				$(this).wrap('<div class="table-responsive"></div>');
				$(this).addClass('data responsive');
			}
		});
	}
	site.content.init();

});
